// Creates a react context for managing the state of which mini promo is shown
// on the filters
import React from "react";

export default React.createContext({
  currentPromoAttribute: null,
  isAPlus: false,
  setCurrentPromoAttribute: () => {}
});
